import { usersApi } from "./users.api";

export const { useGetUsersQuery, useGetUserQuery, useSaveUserMutation, useDeleteUserMutation } = usersApi;
